export default "__VITE_ASSET__CmCjJxsG__"